import { useLightMode } from '@/hooks/useLightMode'
import ReactCrop, {
  type Crop,
  type PercentCrop,
  type PixelCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import { Box, Button, HStack, Text } from '@chakra-ui/react'

const PREVIEW_MAX_HEIGHT = 400

interface FloorPlanCropperIProps {
  imageUrl: string
  crop: Crop | undefined
  onCropChange: (pixelCrop: PixelCrop, percentCrop: PercentCrop) => void
  onReset: () => void
  disabled?: boolean
  onChangePage?: () => void
}

export const FloorPlanCropper = ({
  imageUrl,
  crop,
  onCropChange,
  onReset,
  disabled = false,
  onChangePage,
}: FloorPlanCropperIProps) => {
  const mode = useLightMode()

  return (
    <Box mt={4}>
      <Text
        color={`text.header.${mode}`}
        fontSize='16px'
        fontWeight='500'
        letterSpacing='-0.8px'
        lineHeight='24px'
        mb={2}
        opacity={0.5}
      >
        Drag the edges to trim whitespace from the floor plan
      </Text>

      <Box
        bg='gray.50'
        border='1px solid'
        borderColor='gray.200'
        borderRadius='md'
        overflow='hidden'
        p={4}
      >
        <Box display='flex' justifyContent='center'>
          <ReactCrop
            crop={crop}
            disabled={disabled}
            keepSelection
            onChange={onCropChange}
          >
            <img
              alt='Floor plan preview'
              src={imageUrl}
              style={{
                maxHeight: PREVIEW_MAX_HEIGHT,
                maxWidth: '100%',
                display: 'block',
              }}
            />
          </ReactCrop>
        </Box>

        <HStack justify={onChangePage ? 'space-between' : 'flex-end'} mt={2}>
          {onChangePage && (
            <Button
              isDisabled={disabled}
              onClick={onChangePage}
              size='sm'
              variant='outline'
            >
              Change Page
            </Button>
          )}
          <Button
            isDisabled={disabled}
            onClick={onReset}
            size='sm'
            variant='ghost'
          >
            Reset
          </Button>
        </HStack>
      </Box>
    </Box>
  )
}
